import React from 'react';

import { TvlTreeNodeContentProps } from './types';
import { TvlTreemapArea } from './TvlTreemapArea';

export function TvlTreeNodeContent(props: TvlTreeNodeContentProps) {
  const { x, y, width, height } = props;

  return (
    <foreignObject x={x} y={y} width={width} height={height}>
      <TvlTreemapArea {...props} />
    </foreignObject>
  );
}
